import React, { useState } from 'react';
import { View } from 'react-native';

import { map as _map, findIndex as _findIndex } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import SelectionList, {
  CircularItem,
} from '@vfgroup-oneplatform/foundation/Components/SelectionList';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { OccurrenceTypes } from '../../Utils/AutoTopupTypes';

import styles from './SetupAutoTopUp.Styles';

const getSelectedIndex = occurrence => {
  switch (occurrence?.type) {
    case OccurrenceTypes.WEEKLY:
      return moment().isoWeekday() - 1;
    case OccurrenceTypes.MONTHLY:
      return moment().date() - 1;
    case OccurrenceTypes.AMOUNT:
      return undefined;
  }
};

const SetupAutoTopUp = ({ title, currency, occurrenceOptions, setAutoTopUpData, selectedData }) => {
  const theme = useTheme();

  const _selectedOccurrenceIndex = _findIndex(
    occurrenceOptions,
    option => option?.type === selectedData?.occurrence,
  );
  const [selectedOccurrence, setSelectedOccurrence] = useState(
    occurrenceOptions[_selectedOccurrenceIndex],
  );

  const handleOnSelectValue = (option, index) => {
    setAutoTopUpData({
      occurrence: selectedOccurrence?.type,
      selectedIndex: index,
      selectedValue: selectedOccurrence.options[index],
    });
  };

  const handleSelectedOccurrence = occurrence => {
    setSelectedOccurrence(occurrence);
    const _selectedIndex = getSelectedIndex(occurrence);
    setAutoTopUpData({
      occurrence: occurrence?.type,
      selectedIndex: _selectedIndex,
      selectedValue: occurrence?.options[_selectedIndex],
    });
  };

  const parseCurrency = (arr, parse) => {
    return parse ? _map(arr, option => `${option}${currency}`) : arr;
  };

  return (
    <View style={styles.containerStyle}>
      {occurrenceOptions && (
        <SelectionList
          containerStyle={styles.occurrenceContainer}
          listStyle={styles.listStyle}
          title={title}
          options={_map(occurrenceOptions, (option, index) => ({
            title: option.name,
          }))}
          onSelectOption={(index, option, isActive) =>
            handleSelectedOccurrence(occurrenceOptions[index])
          }
          initialSelectedIndex={_selectedOccurrenceIndex}
          itemWidth={106}
          itemContainerStyle={styles.optionStyle(theme)}
          contentContainerStyle={styles.occurrenceOptionsContainer}
          activeTitleStyle={styles.activeTitleStyle(theme)}
          inActiveTitleStyle={styles.titleStyle(theme)}
        />
      )}
      {selectedOccurrence && (
        <SelectionList
          key={selectedOccurrence.type}
          listStyle={styles.listStyle}
          title={selectedOccurrence.title}
          options={parseCurrency(
            selectedOccurrence.options,
            selectedOccurrence.type === OccurrenceTypes.AMOUNT,
          )}
          customItem={
            <CircularItem localize={selectedOccurrence.type === OccurrenceTypes.WEEKLY} />
          }
          onSelectOption={(index, option, isActive) => handleOnSelectValue(option, index)}
          initialSelectedIndex={selectedData.selectedIndex}
          withInitialScrollToIndex={true}
          itemWidth={49}
          scrollToIndexViewOffset={-14}
          itemContainerStyle={styles.optionStyle(theme)}
          contentContainerStyle={styles.contentContainerStyle}
          activeTitleStyle={styles.activeTitleStyle(theme)}
          inActiveTitleStyle={styles.titleStyle(theme)}
          description={selectedOccurrence.description}
          descriptionStyle={styles.description}
        />
      )}
    </View>
  );
};

SetupAutoTopUp.propTypes = {
  title: PropTypes.string,
  currency: PropTypes.string,
  occurrenceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      options: PropTypes.array,
    }),
  ),
  setAutoTopUpData: PropTypes.func,
  selectedData: PropTypes.shape({
    occurrence: PropTypes.string,
    selectedIndex: PropTypes.number,
    selectedValue: PropTypes.string,
  }),
};

export { getSelectedIndex };
export default SetupAutoTopUp;
